import React, { useState } from 'react';
import { useStateValue } from './AppContext.jsx';
import { makePhotoUrl, makeUrlList, makeVideoUrl } from './AnimalFunctions.jsx';

function AnimalSlider(props) {
  let photosCount = props.photos ? props.photos.length : 0;
  let videosCount = props.videos ? props.videos.length : 0;
  let slideCount = videosCount + photosCount;

  const [ context ] = useStateValue();
  let [ activeSlide, setActiveSlide ] = useState(0);  

  let uploadBase = context.uploadBase;

  switch(slideCount){
    case 0:
      return false;
    case 1:

      if (photosCount == 1) {
        let photoUrl = makePhotoUrl(uploadBase, props.photos, 'medium');
        return(
          <aside className="animalModal_image">
            <img src={photoUrl} alt="" />
          </aside>
          );
      }
      else {
        let videoUrl = makeVideoUrl(props.videos);
        return(
          <aside className="animalModal_image">
             <iframe width="100%" height="350" src={videoUrl}></iframe> 
          </aside>
          );
      }
    default:
      let photoUrls = makeUrlList(uploadBase, props.photos, 'medium', props.videos);

      function goPrev(){
        if(activeSlide === 0){
          setActiveSlide(photoUrls.length - 1);
        }
        else{
          setActiveSlide(activeSlide - 1 );
        }
      }

      function goNext(){
        if(activeSlide + 1 === photoUrls.length){
          setActiveSlide(0)
        }
        else{
          setActiveSlide(activeSlide + 1);
        }
      }

      return(
        <aside className="animalModal_image">          
          <div className="animalModal_image_control">
            <button 
              className="animalModal_slidebutton"
              onClick={goPrev}
              >&laquo;</button>
            {photoUrls.map((photoUrl, i) => (
              <span 
                className={activeSlide === i ? "animalModal_indicator animalModal_indicator-active" : "animalModal_indicator"} 
                role="presentation"
                key={i} 
                />
              ))}
            <button
              className="animalModal_slidebutton"
              onClick={goNext}
              >&raquo;</button>
          </div>          
          {photoUrls[activeSlide].includes("embed") ? (
            <iframe width="100%" height="350" src={photoUrls[activeSlide]}></iframe>
          ) : (
            <img src={photoUrls[activeSlide]} alt="" />
          )}
        </aside>
        )
  }
}

export default AnimalSlider;